import React, { useState } from 'react';
import { HiOutlineInformationCircle } from 'react-icons/hi';
import { FiPlusSquare } from 'react-icons/fi';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { IoFilterSharp } from "react-icons/io5";
import { MagnifyingGlassIcon } from '@heroicons/react/24/solid';
import { ChevronDownIcon } from '@heroicons/react/24/solid';
import Daterange from '../Datarange/Daterange'
import { IoIosArrowRoundDown } from "react-icons/io";
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

const ExploreTable = () => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [checked, setChecked] = useState(false);
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [country, setCountry] = useState('');
  const [selected, setSelected] = useState(null);

  const handleChange = (e) => {
    setChecked(e.target.checked);
  };

  const countries = [
  { code: 'IN', name: 'India', flag: 'https://flagcdn.com/w40/in.png' },
  { code: 'US', name: 'United States', flag: 'https://flagcdn.com/w40/us.png' },
  { code: 'UK', name: 'United Kingdom', flag: 'https://flagcdn.com/w40/gb.png' },
  { code: 'CA', name: 'Canada', flag: 'https://flagcdn.com/w40/ca.png' },
];


const data = [
  {
    id: 1,
    country: 'IN',
    buyer: 'John Doe',
    wanted: 'Electronics',
    post: 'Looking for a used iPhone',
  },
  {
    id: 2,
    country: 'IN',
    buyer: 'John Doe',
    wanted: 'Electronics',
    post: 'Looking for a used iPhone',
  },
  {
    id: 3,
    country: 'IN',
    buyer: 'John Doe',
    wanted: 'Electronics',
    post: 'Looking for a used iPhone',
  },
  {
    id: 4,
    country: 'IN',
    buyer: 'John Doe',
    wanted: 'Electronics',
    post: 'Looking for a used iPhone',
  },
  {
    id: 5,
    country: 'IN',
    buyer: 'John Doe',
    wanted: 'Electronics',
    post: 'Looking for a used iPhone',
  },
  {
    id: 6,
    country: 'IN',
    buyer: 'John Doe',
    wanted: 'Electronics',
    post: 'Looking for a used iPhone',
  },
  {
    id: 7,
    country: 'IN',
    buyer: 'John Doe',
    wanted: 'Electronics',
    post: 'Looking for a used iPhone',
  },
   {
    id: 8,
    country: 'IN',
    buyer: 'John Doe',
    wanted: 'Electronics',
    post: 'Looking for a used iPhone',
  },

]
  
  return (
    <div className="space-y-4 w-full">
      {/* Dropdown Section */}
      <div className="w-full">
        {/* Header */}
     <div className={`flex items-center gap-2 p-2 text-xl border-gray-500 ${openDropdown === 'one' ? '' : 'border-b'}`}>
      {/* Tooltip-enabled icon */}
      <span
        data-tooltip-id="rfqsTooltip"
        data-tooltip-html={`
          <div class='tooltip-bubble'>
            <div class='tooltip-content'>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br />
              Nullam id nulla a elit pharetra gravida. Sed porttitor sapien non ex malesuada.
            </div>
            <div class='tooltip-tail'></div>
          </div>
        `}
        className="mt-1 cursor-pointer text-gray-700"
      >
        <HiOutlineInformationCircle />
      </span>

      <h1 className='text-gray-700'>RFQS</h1>
        <FiPlusSquare
        className="text-blue-600 cursor-pointer"
        onClick={() => setOpenDropdown(openDropdown === 'one' ? null : 'one')}
      />
      <div
        className="cursor-pointer"
        onClick={() => setOpenDropdown(openDropdown === 'one' ? null : 'one')}
      >
        {openDropdown === 'one' ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
      </div>

      {/* Tooltip component */}
      <Tooltip
        id="rfqsTooltip"
        place="bottom"
        offset={10}
        className="!bg-transparent !p-0 !rounded-none ms-28 mt-36"
      />
      
    </div>
        {/* Dropdown Content */}
        <div
          className={`transition-all duration-500 overflow-hidden text-sm w-full ${openDropdown === 'one' ? 'min-h-min rounded-t-md max-h-screen' : 'max-h-0 border-0 rounded-none'
            }`}
        >
          <h3 className='text-sm text-gray-700 p-2 '>select only 4 Product and high Demand/Hot Enquries</h3>
          <div className="w-full min-h-min overflow-y-auto scrollbar-hide">

           <div className="relative flex gap-3 ">

         <div className="relative max-w-md ">
  {/* Search Icon on the right */}
  <span className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
    <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
  </span>

  <input
    type="text"
    placeholder="Search..."
    value={searchTerm}
    onChange={e => setSearchTerm(e.target.value)}
    className="w-full pr-10 pl-4 py-2 border rounded shadow-sm focus:outline-none focus:ring"
  />
</div>

<div className="relative w-44">
      <div
        className="border border-gray-300 rounded-md px-4 py-2 cursor-pointer flex items-center justify-between"
        onClick={() => setOpen(!open)}
      >
        <span>
          {selected ? (
            <span className="flex items-center gap-2">
              <img src={selected.flag} alt={selected.code} className="w-5 h-5" />
              {selected.name}
            </span>
          ) : (
            ' Country'
          )}
        </span>
        <ChevronDownIcon className="h-5 w-5" />
      </div>

      {open && (
        <ul className="absolute z-10 mt-1 w-full border bg-white rounded shadow">
          {countries.map((c) => (
            <li
              key={c.code}
              onClick={() => {
                setSelected(c);
                setOpen(false);
              }}
              className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 cursor-pointer"
            >
              <img src={c.flag} alt={c.code} className="w-5 h-5" />
              {c.name}
            </li>
          ))}
        </ul>
      )}
    </div>

    <div className=''>
      <Daterange/>
    </div>


      <div
  className="flex items-center gap-2 w-fit h-7 px-3 ml-64 mt-1  bg-gray-200 text-gray-700 hover:bg-gray-400 cursor-pointer select-none rounded"
  onClick={() => setOpen((prev) => !prev)}
>
  <IoFilterSharp className="text-sm" />
  <span className="text-sm font-medium ">Newly Added on Top</span>
</div>

      {/* Dropdown menu */}
      {open && (
        <div className="absolute right-0 mt-8 bg-white border rounded shadow-lg w-48 z-50">
          <ul className='p-1'>
            <li className="p-3 hover:bg-gray-200 cursor-pointer">Buyer RFQS</li>
            <li className="p-3 hover:bg-gray-200 cursor-pointer">Seller RFQS</li>
            <li className="p-3 hover:bg-gray-200 cursor-pointer">Newest RFQS</li>
            <li className="p-3 hover:bg-gray-200 cursor-pointer">Oldest RFQS</li>
            
          </ul>
        </div>
      )}
    </div>

<div className="mt-1">
  <div className="overflow-x-auto">
    <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-sm">
      <thead className="bg-gray-100">
        <tr>
          <th className="text-center px-4 py-2 border-b border-r">
            <input type="checkbox" className="scale-125" />
          </th>
        

<th className="text-center px-4 py-2 border-b border-r">
  <span className="inline-flex items-center justify-center">
    Country
    <IoIosArrowRoundDown className="ml-1 text-xl" />
  </span>
</th>

<th className="text-center px-4 py-2 border-b border-r">
  <span className="inline-flex items-center justify-center">
    Buyer/Seller With country
    <IoIosArrowRoundDown className="ml-1 text-xl" />
  </span>
</th>

<th className="text-center px-4 py-2 border-b border-r">
  <span className="inline-flex items-center justify-center">
    Wanted
    <IoIosArrowRoundDown className="ml-1 text-xl" />
  </span>
</th>
  <th className="text-center px-4 py-2 border-b">
  <span className="inline-flex items-center justify-center">
    RFQS Posted on
    <IoIosArrowRoundDown className="ml-1 text-xl" />
  </span>
</th>
        </tr>
      </thead>
      <tbody>
        {data.map((user) => (
          <tr key={user.id} className="hover:bg-gray-50">
            <td className="text-center py-2 border-b border-r">
              <input type="checkbox" className="scale-125" />
            </td>
            <td className="text-center py-2 border-b border-r">
  <div className="flex items-center justify-center gap-2">
    <img
      src={`https://flagcdn.com/w40/${user.country.toLowerCase()}.png`}
      alt={user.country}
      className="w-5 h-4 rounded-sm"
    />
    <span>{user.country}</span>
  </div>
</td>
            <td className="text-center py-2 border-b border-r">{user.buyer}</td>
            <td className="text-center py-2 border-b border-r">{user.wanted}</td>
            <td className="text-center py-2 border-b">{user.post}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</div>


            
          </div>
        </div>


      </div>
    </div>
  );
};

export default ExploreTable;
